import Slider from 'react-slick';
import Slide from './Slide/Slide';
import React, { Component } from 'react';
import { getShowcaseSliderConfig } from './sliderConfig';
import { BenefitSlide } from '../../types/content';

interface IAdvantagesSliderProps {
  slideTitles: string[];
  slides: object[];
}

export let slider: Slider
export default class AdvantagesSlider extends Component <IAdvantagesSliderProps> {

  constructor(props: any) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    slider.slickPause();
  }

  handleScroll() {
    let sliderElement = document.querySelector('.advantages-wrapper');
    if (sliderElement.getBoundingClientRect().top <= 400)
      slider.slickPlay();
  }

  render() {
    return (
      <div onScroll={this.handleScroll} id={'advantages_slider'}>
        <Slider ref={sliderCreated => (slider = sliderCreated)} {...getShowcaseSliderConfig(this.props.slideTitles)}>
          {this.props.slides.filter((slide: BenefitSlide) => slide.visible === 'yes').map((slide: BenefitSlide, index) => (
            <div key={`adantage_slide_${index}`} className="slide-wrapper">
              <Slide slide={slide} index={index} />
            </div>)
          )}
        </Slider>
      </div>
    );
  }
}

